import api from '../../ApiConfig';
import { Apis } from '../../config';



const createFaq = async (data) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.CreateFaq, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
};
const getFaqs = async () => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetFaqs,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
};
const getSingleFaq = async (id) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.GetSingleFaq + id,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
};
const updateFaq = async (data, id) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.post(Apis.UpdateFaq + id, data,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
};
const deleteFaq = async (id) => {
    try {
        var token =  sessionStorage.getItem('userToken');
        let result = await api.get(Apis.DeleteFaq + id,{
            headers: {
                'x-access-token': token
            }    
        });
        if (result.data.error) {
            return null;
        }
        return result.data;
        
    } catch (error) {
        return error;
    }
};





const exportedObject = {
    createFaq,
    getFaqs,
    getSingleFaq,
    updateFaq,
    deleteFaq
};
export default exportedObject;